module.exports = __webpack_public_path__ + "static/media/1.28 FOTO 3.768ff642.png";